import * as React from "react";
import ExternalLink from "~/components/Navigation/ExternalLink";
import { Note } from "~/components/form";
import type { CategoryDefinition } from "./endpointRegistry";
const category: CategoryDefinition = {
    category: "Mac",
    title: (<React.Fragment>
            What type of <strong>Mac target</strong> do you want to set up?
        </React.Fragment>),
    help: (<Note>
            Learn more about <ExternalLink href="SSHTargets">SSH Targets</ExternalLink>
        </Note>),
    displayOrder: 30,
};
export default category;
